import { useLocation } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

/**
 * Map authenticated routes to their human-friendly tab title.  Public pages
 * (`/p/:slug`, `/login`, etc.) set their own title from inside the page so
 * they can include dynamic data (product name, etc.).
 */
const ROUTE_TITLES = {
  "/": "Dashboard",
  "/guia": "Guía & flujo",
  "/inventario": "Inventario",
  "/catalogo-imprimible": "Catálogo imprimible",
  "/escanear": "Escanear con IA",
  "/publicaciones": "Publicaciones",
  "/bandeja": "Bandeja auto",
  "/conversaciones": "Conversaciones",
  "/ventas": "Ventas",
  "/referidos": "Referidos",
  "/suscriptores": "Suscriptores",
  "/reportes": "Reportes",
  "/ajustes": "Ajustes",
  "/auditoria": "Auditoría",
  "/login": "Iniciar sesión",
  "/forgot-password": "Recuperar contraseña",
  "/reset-password": "Nueva contraseña",
};

export default function RouteTitle() {
  const { pathname } = useLocation();
  // Public product pages own their own title.
  const skip = pathname.startsWith("/p/");
  const title = skip ? null : ROUTE_TITLES[pathname] || "";
  useDocumentTitle(skip ? "" : title || "Plataforma");
  return null;
}
